import Page from '../../../../assets/js/classes/Page'

import each from 'lodash/each'
import map from 'lodash/map'

// App Store
import { app } from '../../../../assets/js/utils/store'

// User Detect
import { DetectionManager } from '../../../../assets/js/utils/detect'

// Navigation
// import { Navigation, Footer } from './modules/Navigation'
// import { BottomBar } from './modules/BottomBar'

// Classes::Managers
import { CursorManager } from "../../../../assets/js/modules/Cursor"
import { AccordionManager } from '../../../../assets/js/classes/Accordions'
import { DropdownManager } from '../../../../assets/js/classes/Dropdowns'
import { TogglerManager } from '../../../../assets/js/classes/Togglers'
import { ModalManager } from '../../../../assets/js/classes/Modal'
import { ScrollManager } from '../../../../assets/js/classes/Scroll'

import Form from '../../../../assets/js/classes/Forms'
import Carousel from './modules/Carousel'

// AsyncLoad
import AsyncLoad from '../../../../assets/js/classes/AsyncLoad'

// Module
import Preloader from '../../../../assets/js/modules/Preload'

export default class App extends Page {
    constructor(){
        app.init = true
        app.root = document.body
        app.viewport = document.querySelector('[data-app-viewport]')
        app.content = document.getElementById("app-content")

        //Async Load
        app.images = document.querySelectorAll('[data-src][data-webp]')

        super({
            id : 'landing_case',
            element: '[data-app-page]',
            elements: { 
                hero : document.querySelectorAll('[data-carousel="hero"]'),
            }
        })

        this.create()
    }
    
    create() {
        super.create()
        
        app.create = {
            preloaders: this.createPreloaders.bind(this),
            content: this.createContent.bind(this),
            accordions: this.createAccordions.bind(this),
            dropdowns: this.createDropdowns.bind(this),
            togglers: this.createTogglers.bind(this),
            modals: this.createModals.bind(this),
            carousels: this.createCarousels.bind(this),
            scroll: this.createScroll.bind(this),
        }
        
        map(app.create, (callback) => { return callback() })
        app.loading = false

        console.log(app)

    }

     // Create Content
     createContent = () => {
        this.template = app.root.getAttribute('data-template')
        this.content = document.querySelector('[data-app-content]')

        this.wrapper = document.querySelector('[data-wrapper]')

        // this.menu = document.querySelectorAll('[data-navigation-menu]')

        this.anchors = document.querySelectorAll('a[href*="#"]:not([href="#"])')

        this.accordion = { togglers: document.querySelectorAll('.accordion-button'), }
        this.dropdown = { togglers: document.querySelectorAll('[data-bs-toggle="dropdown"]'), }
        this.click = { togglers: document.querySelectorAll('[data-click-target]'), }
        this.modal = {
            elements: document.querySelectorAll('[data-modal]'),
            togglers: document.querySelectorAll('[data-modal-target]'),
            closers: document.querySelectorAll('[data-modal-close]')
        }

        // this.statusbar = document.querySelector('[data-navigation-bottom-bar]')
        this.forms = document.querySelectorAll('form')
        this.search = document.getElementById('global-search')

        this.carousels = document.querySelectorAll('[data-carousel]')
        this.finishes = document.querySelectorAll('ul.list--materials')

        app.current = this.template
        app.wrapper = this.wrapper

        app.scroll = window

        app.page = this

        // if (app.page) {
        //     app.page.create()
        // }
    }

    // Create Preloaders
    createPreloaders = () => {
        // if(!sessionStorage.getItem('init')){ 
        app.preloader = new Preloader()
        app.preloader.once('completed', this.onPreloaded.bind(this))
        // } else {
        // this.onPreloaded()
        // }
    }

    // Create Accordions
    createAccordions = () => {
        each(this.accordion.togglers, (accordion) => AccordionManager.create(accordion))
    }

    // Create Dropdowns
    createDropdowns = () => {
        each(this.dropdown.togglers, (dropdown) => DropdownManager.create(dropdown))
    }

    // Create Togglers
    createTogglers = () => {
        each(this.click.togglers, (toggler) => TogglerManager.toggle(toggler))
    }

    // Create Modals
    createModals = () => {
        each(this.modal.togglers, (toggler) => ModalManager.toggle(toggler))
        each(this.modal.closers, (closer) => ModalManager.close(closer))
    }

    // Create Scroll
    createScroll = () => {
        if (this.anchors) {
            this.anchors.forEach((link) => ScrollManager.scrollBehaviour(link))
        }
    }

    // Create Forms
    createForms = () => {
        if (this.forms) {
            each(this.forms, (form) => { return new Form({ element: form }) })
        }

        if (this.search) {
            this.search = new Search()
        }
    }

    createCarousels = () => {
        if (this.carousels) {
            each(this.carousels, (carousel) => { return new Carousel({ element: carousel }) })
        }
    }
    
    addEventListeners() {   
    }

    /*
    ** Events
    */

    // On Loaded
    onPreloaded() {
        app.loading = false
        app.html.classList.remove('loading')
        app.html.classList.remove('scroll--off')

        ScrollManager.onLoadAnchor()

        this.preloaders = each(app.images, image => {
            return new AsyncLoad({ element: image })
        })

        // Display Contents (Critical Visuals)
        if (app.nav) {
            // app.nav.querySelector('[data-main-actions]').style.removeProperty('visibility')
            // app.nav.querySelector('[data-main-actions]').style.setProperty('transition', 'background-color 0.4s cubic-bezier(0.83, 0, 0.17, 1), translate 1s cubic-bezier(0.83, 0, 0.17, 1);')
            each(app.nav.querySelectorAll('[data-navigation-menu]'), (menu) => { menu.style.removeProperty('visibility') })
            app.nav.querySelector('[data-main-actions]').style.setProperty('visibility', 'visible')
        }
        if (this.modal.elements) { each(this.modal.elements, (modal) => { modal.style.removeProperty('visibility') }) }

        // this.preloaders = each(app.images, image => {
        //     return new AsyncLoad({ element: image })
        // })

        // this.videos = each(app.videos, video => {
        //     return new Video({ element: video })
        // })

        if (app.init && app.preloader) { app.preloader.destroy() }
        // this.onResize
        // app.scroll.scrollTop = 0
    }

    destroy(){ 
        super.destroy()
    }
}

new App()